export { default } from './PatientDevicePopup';
